import { render, staticRenderFns } from "./WareHouses.vue?vue&type=template&id=6ac962ba&"
import script from "./WareHouses.vue?vue&type=script&lang=js&"
export * from "./WareHouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac962ba')) {
      api.createRecord('6ac962ba', component.options)
    } else {
      api.reload('6ac962ba', component.options)
    }
    module.hot.accept("./WareHouses.vue?vue&type=template&id=6ac962ba&", function () {
      api.rerender('6ac962ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/warehouses/views/WareHouses.vue"
export default component.exports